// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useRef, useEffect } from 'react';
import './FontSizeSettings.css';

const FontSizeSettings = ({ fontSize, onFontSizeChange, readingFamily, onReadingFamilyChange }) => {
    const [showSettings, setShowSettings] = useState(false);
    const settingsRef = useRef(null);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const handleClickOutside = (event) => {
        if (settingsRef.current && !settingsRef.current.contains(event.target)) {
            setShowSettings(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const setStandardFamily = () => {
        if (onReadingFamilyChange) {
             onReadingFamilyChange('standard');
        }
    };

    const setWarmFamily = () => {
        if (onReadingFamilyChange) {
             onReadingFamilyChange('warm');
        }
    };

    const sizes = [
        { id: 'small', label: 'Small', iconClass: 'fi fi-br-a', sizeClass: 'small-icon' },
        { id: 'medium', label: 'Medium', iconClass: 'fi fi-br-a', sizeClass: 'medium-icon' },
        { id: 'large', label: 'Large', iconClass: 'fi fi-br-a', sizeClass: 'large-icon' }
    ];

    return (
        <div className="font-settings-wrapper relative flex items-center" ref={settingsRef}>
            <button 
                className={`font-settings-btn flex items-center justify-center rounded-full border-none bg-none p-[6px] text-[1.2rem] leading-[0] text-[#444] transition-all duration-200 hover:bg-black/5 hover:text-black ${showSettings ? 'active text-[#47b5ff]' : ''}`}
                onClick={toggleSettings}
                title="Display Settings"
            >
                <i className="fi fi-rr-text-box-edit"></i>
            </button>

            {showSettings && (
                <div className="font-settings-popup absolute right-0 top-full z-[1000] mt-[15px] min-w-[150px] rounded-[12px] border border-[#ddd] bg-white px-[15px] py-[12px] shadow-[0_4px_12px_rgba(0,0,0,0.15)]">
                    {/* Text Size Section */}
                    <div className="font-settings-section flex flex-col">
                        <div className="font-settings-label mb-[10px] text-center text-[0.9rem] font-[500] text-[#666]">Text Size</div>
                        <div className="font-size-options flex flex-row items-center justify-center gap-[15px]">
                            {sizes.map((size) => (
                                <button
                                    key={size.id}
                                    className={`font-size-option flex items-center justify-center rounded-[6px] border-none bg-transparent p-[6px] text-[#555] transition-all duration-200 hover:bg-black/5 ${fontSize === size.id ? 'active bg-[#e7f5ff] text-[#47b5ff]' : ''}`}
                                    onClick={() => onFontSizeChange(size.id)}
                                    title={`${size.label} Font Size`}
                                >
                                    <i className={`${size.iconClass} ${size.sizeClass}`}></i>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="font-settings-divider my-[12px] h-[1px] bg-[#eee]"></div>

                    {/* Reading Theme Section */}
                    <div className="font-settings-section flex flex-col">
                        <div className="font-settings-label mb-[8px] text-center text-[0.9rem] font-[500] text-[#666]">Reading Theme</div>
                        <div className="theme-options flex flex-row items-center justify-center gap-[15px]">
                            {/* Standard B&W Toggle */}
                            <button
                                className={`theme-option relative flex items-center justify-center rounded-full border-2 border-transparent bg-transparent p-[2px] outline-none transition-all duration-200 ${readingFamily === 'standard' ? 'active border-[#47b5ff] bg-[rgba(71,181,255,0.1)]' : ''}`}
                                onClick={setStandardFamily}
                                title="Standard"
                            >
                                <div 
                                    className="theme-circle"
                                    style={{ background: 'linear-gradient(45deg, #ffffff 50%, #000000 50%)', border: '1px solid #ddd' }}
                                ></div>
                            </button>

                            {/* Custom Colors Toggle */}
                            <button
                                className={`theme-option relative flex items-center justify-center rounded-full border-2 border-transparent bg-transparent p-[2px] outline-none transition-all duration-200 ${readingFamily === 'warm' ? 'active border-[#47b5ff] bg-[rgba(71,181,255,0.1)]' : ''}`}
                                onClick={setWarmFamily}
                                title="Warm/Deep Dark"
                            >
                                <div 
                                    className="theme-circle"
                                    style={{ background: 'linear-gradient(45deg, #FFF8DE 50%, #101010 50%)', border: '1px solid #ddd' }}
                                ></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FontSizeSettings;

